$(document).ready(function() {
    var form = $('form[name="frmLoginPub"]');
    var submit = form.find('input[type="submit"]');
    var email = form.find('input[type="email"]');
    var password = form.find('input[type="password"]');
    var emailError = $("#login-email-error");
    var passwordError = $("#login-password-error");

    submit.on('click', function(e) {
        e.preventDefault();

        var errors = false;

        if(email.val().length === 0) {
            emailError.show();
            errors = true;
        } else {
            emailError.hide();
        }

        if(password.val().length === 0) {
            passwordError.show();
            errors = true;
        } else {
            passwordError.hide();
        }


        if(!errors) {
            form.submit();
        }
    });
});